export default __webpack_public_path__ + "static/media/occam-logo.5acd6aa2.svg";